import { IndustrialProcessType } from "../types";

const TRANSLATED_INDUSTRIAL_PROCESS: Record<IndustrialProcessType, string> = {
  ASSEMBLING: "Assemblage",
  BENDING: "Cintrage",
  CHIMIC_ENGRAVING: "Gravure chimique",
  COMBINED_PUNCHING_LASER: "Combiné poinçonnage laser",
  CONTROL: "Contrôle",
  COUNTERSINKING: "Fraisurage",
  CRIMPING: "Sertissage",
  DEBURRING: "Ebavurage",
  DRILLING: "Perçage",
  ELECTRO_EROSION: "Electro-érosion",
  ENGRAVING: "Gravure",
  FOLDING: "Pliage",
  GRINDING: "Meulage",
  HEAT_TREATMENT: "Traitement thermique",
  LASER_CUT: "Découpe laser",
  MATERIAL: "Matière",
  MILLING: "Fraisage",
  OTHER: "Autre",
  OUTSOURCING: "Sous-traitance",
  PACKING: "Emballage",
  PLASMA_CUT: "Découpe plasma",
  PRESSING: "Pressage",
  PRODUCTS: "Achats",
  PUNCHING: "Poinçonnage ",
  RIVETING: "Rivetage",
  ROLLING: "Roulage",
  SAWING: "Sciage",
  SHEARING: "Cisaillage",
  SIMPLE: "Simple",
  SURFACE_TREATMENT: "Traitement de surface",
  TAPPING: "Taraudage",
  TRANSPORT: "Transport",
  TRIMMING: "Détourage",
  TURNING: "Tournage / Décolletage",
  UNSTAPLING: "Dégrafage",
  WATER_CUT: "Découpe jet d'eau",
  WELDING: "Soudure",
};

export const getProcessStepName = (processStep: {
  industrialProcess: IndustrialProcessType | null;
  description: string | null;
}) => {
  return (
    processStep.description ||
    (processStep.industrialProcess
      ? TRANSLATED_INDUSTRIAL_PROCESS[processStep.industrialProcess]
      : "")
  );
};
